export function generateCardMaskedNumber(cardNumber: string) {
  return cardNumber.substring(0, 6) + cardNumber.substring(cardNumber.length - 4);
}
